module.exports = __webpack_public_path__ + "static/media/marker-home.258e44a6.svg";